<template>
  <div class="about-wrapper clearfix">
    <div class="left">
      <div
        v-for="(item,idx) in arrTabs"
        :key="idx"
        :class="[idx==tabIndex?'tab-on':'tab-un','tab']"
        @click="tabClick(idx)"
      >{{item}}</div>
    </div>
    <div class="right">
      <div v-if="tabIndex==0">
        <span style="font-size: 44px;color: #dc371b;">公司简介</span>
        <p style="color: #dc371b;">恋撩话术 ———— 愿天下有情人终成眷属，是前生造定事莫错过姻缘!</p>
        <p style="text-align:left;text-indent:2em;">
          恋撩话术属于灵宝诚田网络科技有限公司。是一家专注于情感心理和情侣恋爱、情感问题以及提升社交能力为主的互联网企业。恋撩话术作为一款综合情感知识、 恋爱脱单、聊天技巧、情感修复、分手挽回、形象气质提升等领域的专栏内容。海量内容知识供你学习，帮助用户解决在情感、心理、婚姻与家庭层面的问题。 恋撩话术与传统的情感咨询、婚恋机构不同，恋撩话术不是资源匹配式相亲，而是以海量知识内容教学式和理论、实践经验丰富的情感导师团队在线解答式为主的情感教育平台。 恋撩话术助你提升生活幸福感，让你从青涩少年到微熟男女，从同窗情愫到邂逅佳人，扩展你的交际圈让爱得偿所愿。
        </p>
      </div>
      <div v-if="tabIndex==1">
        <span style="font-size: 44px;color: #dc371b;">联系我们</span>
        <div class="clearfix" style="margin-top:60px;width:100%;">
          <div class="contact" style="float:left;">
            <img
              src="../assets/call1.png"
              alt=""
            >
            <span>联系人：王先生</span>
            <span>邮箱：851544641@qq.com</span>
          </div>
          <div class="contact" style="float:right;">
            <img
              src="../assets/call2.png"
              alt=""
            >
            <span>联系人：王先生</span>
            <span>邮箱：15510325@qq.com</span></div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'about',
  data () {
    return {
      arrTabs: [
        '公司简介',
        '联系我们'
      ],
      tabIndex: 0
    };
  },
  props: {
    index: Number
  },
  methods: {
    tabClick (index) {
      this.tabIndex = index
      this.$emit('tabclick', index)
    }
  },
  watch: {
    index (newValue, old) {
      console.log(old)
      this.tabIndex = newValue - 2
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.about-wrapper {
  padding: 60px;
  width: 100%;
  box-sizing: border-box;
}
.about-wrapper .tab-on {
  background: #dc371b;
  color: #fff;
}

.about-wrapper .tab-un {
  background: #f3f3f3;
  color: #9e9e9e;
}

.about-wrapper .tab {
  width: 188px;
  height: 64px;
  line-height: 64px;
  cursor: pointer;
  font-size: 26px;
  margin-bottom: 30px;
}

.about-wrapper .left {
  float: left;
  text-align: center;
}

.about-wrapper .right {
  text-align: center;
  width: 830px;
  min-height: 500px;
  margin-left: 60px;
  font-size: 22px;
  float: left;
}

.about-wrapper .contact{
  width: 300px;
  text-align: center;
  height: 400px;
  box-shadow:  0 0 10px #ddd;
}

.about-wrapper .contact img{
  width: 300px;
  height: 177px;
  margin-bottom: 20px;
}

.about-wrapper .contact span{
  display: block;
  margin-top: 10px;
}


</style>
